import axios from "axios";

function remotePost(url, data) {
    return axios.post(url, data).then(response => response.data)
}

export {
    remotePost
}
